// src/data/starQuest.js
// 1 star per chapter from 2→9 (8 total)
export const starChapters = {
  "chapter-2": { treblin: "Zeb the Zebra", song: "Happy Birthday", stars: 1 },
  "chapter-3": { treblin: "Peng the Penguin", song: "Ode to Joy", stars: 1 },
  "chapter-4": { treblin: "Spider Clan", song: "Incy Wincy Spider", stars: 1 },
  "chapter-5": { treblin: "Rudolph & Friends", song: "Jingle Bells", stars: 1 },
  "chapter-6": { treblin: "Panda Family", song: "Titan Theme (Easy)", stars: 1 },
  "chapter-7": { treblin: "Peacocks", song: "The National Anthem (Easy)", stars: 1 },
  "chapter-8": { treblin: "—", song: "Pop Song (TBD)", stars: 1 },
  "chapter-9": { treblin: "Crocodiles", song: "Do-Re-Mi (Easy)", stars: 1 },
};
// Chapter 1 explains the quest but awards no star.
